// Web stub for expo-cached-image.
// On web, CachedImage always uses React Native's <Image> directly and never
// renders ExpoCachedImage, so this module just needs to exist without
// running native-only initialisation code (Paths.cache.uri from expo-file-system).
import { Image } from 'react-native';
export default Image;
